import { UPDATE_DCC_DATA } from "../helpers/actions";
import { withProperties, isPlainObject } from "../../utils";

export default function state() {
  const NAME = 'dcc';
  const $state = Object.create(null);

  function Reducer(state = null, action) {
    const payload = isPlainObject(action.payload) ? action.payload : {};

    switch (action.type) {
      case UPDATE_DCC_DATA: {
        const { dcc } = payload;
        return dcc || null;
      }

      default: return state;
    }
  }

  // Augment $state with properties
  withProperties($state, {
    NAME,
    Reducer
  });

  return (state = $state);
}
